export const BUS_STOP_RENDER_CONFIG = Object.freeze({
  poleHeightM: 3.42,
  poleRadiusM: 0.062,
  namePlateWidthM: 1.72,
  namePlateHeightM: 0.52,
  flagDepthM: 0.085,
  namePlateCenterHeightM: 3.13,
  routePlateWidthM: 1.58,
  routePlateHeightM: 0.36,
  routePlateCenterHeightM: 2.66,
  timetableWidthM: 0.5,
  timetableHeightM: 0.8,
  timetableCenterHeightM: 1.88,
  nameTextMaximumHeightM: 0.3,
  routeTextMaximumHeightM: 0.125,
  maximumStopNameCharacters: 24,
  maximumRouteCharacters: 24,
  maximumDirectionCharacters: 24,
  maximumOrientationRoadDistanceM: 36,
});
